<div class="model-approval">
  <div class="approval-form">
    <gen-dynamic-form
      [formData]="data"
      (formChange)="formChanged(data, $event.form)"
      (linkClick)="downloadApprovalPdf($event)"
      [formName]="payload.config.formName"
      [editMode]="false"
      [disabled]="false"
      [formVertical]="true"
    ></gen-dynamic-form>
  </div>
  <div class="model-approval-actions-container">
    <div class="model-approval-actions" *ngIf="payload.config.actions">
      <gen-button *ngIf="payload.config.actions.cancel"
                  [ngClass]="payload.config.actions.cancel.cssClass"
                  (click)="callback(undefined)"
                  [type]="payload.config.actions.cancel.type"
                  [text]="payload.config.actions.cancel.text"></gen-button>
      <gen-button [ngClass]="payload.config.actions.save.cssClass"
                  (click)="callback(data)"
                  [type]="payload.config.actions.save.type"
                  [text]="payload.config.actions.save.text"></gen-button>
    </div>
  </div>
</div>
